import { VISIBILITY } from 'constants/ChatConstants';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

/**
 * @typedef {Array<string>} CountByTypeAllExternalReducer
 */
const initialState = [];

/**
 *
 * @param {CountByTypeAllExternalReducer} _
 * @param {import('modules/chat/types').FetchUnreadCountsByTypeSuccessAction} action
 * @returns {CountByTypeAllExternalReducer}
 */
const update = (_, { payload }) => payload.external.all;

/**
 * @param {CountByTypeAllExternalReducer} state
 * @param {import('modules/sockets/types/actions').PutSocketMessageAction & {
 *   payload: {
 *     data: {
 *      message: import('modules/chat/types/message').Message,
 *      myClients: boolean,
 *     }
 *   }
 * }} action
 * @returns {CountByTypeAllExternalReducer}
 */
const updateFromNewMessage = (state, { payload }) => {
  const { message } = payload;
  return !state.includes(message.conversationId) && message.visibility === VISIBILITY.PUBLIC
    ? [...state, message.conversationId]
    : state;
};

export default createReducer(initialState, {
  [actionTypes.FETCH_UNREAD_COUNTS_BY_TYPE_SUCCESS]: update,
  [actionTypes.RECEIVE_MESSAGE_FROM_SOCKET]: updateFromNewMessage,
});
